import { Expose } from "class-transformer";

export default class EtsDeclarationResponse {
  @Expose({ name: "redirect_uri" })
  redirectUri!: string;
}
